import React from "react";
import { FOUNDATION_INFO } from "@/lib/initiatives";

// WhatsApp click-to-chat FAB. Uses the foundation phone (no country prefix rules — wa.me will handle).
export default function WhatsAppFab() {
  const phone = FOUNDATION_INFO.phone.replace(/[^0-9]/g, "");
  const msg = encodeURIComponent(
    "Hello UB Maitreya Foundation, I would like to know more about your initiatives."
  );
  return (
    <a
      href={`https://wa.me/${phone}?text=${msg}`}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat with us on WhatsApp"
      data-testid="whatsapp-fab"
      className="fixed bottom-6 right-6 z-50 group flex items-center gap-3 rounded-full bg-[#25D366] text-white pl-3 pr-5 py-3 shadow-lg hover:shadow-xl transition-all hover:scale-105"
    >
      <span className="w-9 h-9 rounded-full bg-white/20 flex items-center justify-center">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" className="w-5 h-5 fill-white">
          <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.966-.273-.099-.471-.148-.67.15-.198.297-.767.966-.94 1.164-.173.198-.347.223-.644.074-.297-.149-1.255-.462-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.372-.025-.521-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51l-.57-.01c-.198 0-.52.074-.792.372s-1.04 1.016-1.04 2.479 1.065 2.876 1.213 3.074c.149.198 2.096 3.2 5.077 4.487.71.306 1.263.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347zM12.05 2C6.501 2 2 6.5 2 12.05c0 1.965.577 3.796 1.566 5.336L2 22l4.735-1.545a10.001 10.001 0 0 0 5.315 1.5c5.55 0 10.05-4.5 10.05-10.05C22.1 6.5 17.6 2 12.05 2z" />
        </svg>
      </span>
      <span className="hidden sm:inline text-sm font-medium">Chat on WhatsApp</span>
    </a>
  );
}
